import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FieldConfigName} from '../../../models';
import {TextAreaDialogComponent} from './text-area-dialog.component';
import {FieldControlMaster} from '../control-master-label-required';

@Component({
  selector: 'app-text-area-input',
  templateUrl: './text-area-input.component.html',
  styleUrls: ['./text-area-input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TextAreaInputComponent extends FieldControlMaster implements OnInit {
  @Output() textAreaUpdateControl = new EventEmitter<{ control: FieldConfigName, index: number }>();
  @Output() textAreaDelete = new EventEmitter<number>();
  dialogComponent = TextAreaDialogComponent;
  constructor() {
    super();
  }

  ngOnInit(): void {
  }
  onUpdatedControl(object) {
    this.textAreaUpdateControl.emit(object);
  }
  onDeletedControl(index: number) {
    this.textAreaDelete.emit(index);
  }
}
